import React, { useEffect, useState } from "react";
import { getAccuracy } from "../../lib/api";
import { BadgeCheck } from "lucide-react";

// Trust signal — stays hidden until we have a robust verified sample (visible=false from API).
export const AccuracyBadge = ({ variant = "landing" }) => {
  const [data, setData] = useState(null);

  useEffect(() => { getAccuracy().then(setData).catch(() => {}); }, []);

  if (!data || !data.visible) return null;

  const text = `Predicts within \u00B1${data.within_points}% of the final university mark`;
  const sub = `Based on ${data.sample_size.toLocaleString()} verified assignments`;

  if (variant === "report") {
    return (
      <div className="mt-6 border border-[#15803D]/30 bg-[#F0FDF4] px-5 py-3 flex items-center gap-3" data-testid="accuracy-badge-report">
        <BadgeCheck size={18} className="text-[#15803D] shrink-0" />
        <p className="text-[13px] text-[#166534] leading-snug"><b>{text}.</b> {sub}.</p>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 border border-oxford/20 bg-oxford/[0.04] px-4 py-2 mb-8" data-testid="accuracy-badge-landing">
      <BadgeCheck size={16} className="text-oxford shrink-0" />
      <span className="text-sm text-foreground"><b>{text}</b> · {sub}</span>
    </div>
  );
};
